export default __webpack_public_path__ + "static/media/logo.b4601a1e.png";